"use client";

import { QueryClient } from "@tanstack/react-query";

// Singleton QueryClient (pola resmi Next App Router). Satu instance di browser
// supaya cache board bertahan lintas-navigasi (instant-render saat balik ke
// board) DAN bisa diakses imperatif (lihat `invalidateBoard` di boardQueries.ts)
// sebagai pengganti `bustBoardCache` lama.

function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Anggap data segar 30 dtk; setelah itu refetch latar saat ada pemicu.
        staleTime: 30_000,
        // Pertahankan cache ~5 mnt setelah query tak dipakai (unmount tab/halaman)
        // → tiba lagi di board langsung render dari cache, lalu revalidate latar.
        gcTime: 300_000,
        // Board punya pemicu refetch eksplisit (refetchOnMount/invalidate); jangan
        // kejutkan dengan refetch saat fokus jendela.
        refetchOnWindowFocus: false,
        retry: 1
      }
    }
  });
}

let browserQueryClient: QueryClient | undefined;

export function getQueryClient(): QueryClient {
  // Server: selalu instance baru (tak ada singleton lintas-request).
  if (typeof window === "undefined") return makeQueryClient();
  // Browser: satu instance dipakai ulang.
  if (!browserQueryClient) browserQueryClient = makeQueryClient();
  return browserQueryClient;
}
